/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AuthenticationType = {
    UsernamePassword: 'USERNAME_PASSWORD',
    Oidc: 'OIDC',
    Ldap: 'LDAP'
} as const;

export type AuthenticationType = typeof AuthenticationType[keyof typeof AuthenticationType];



